<template>
    <div class="step baths">
        <AdvTitle
        >{{ $t("common:signLog.adv.bathTitle") }}</AdvTitle
        >
        <div class="adv-btn-group baths-choose">
            <AdvBtn
                v-for="item in list"
                :key="item"
                type="reverse"
                @click="handleNext(item === 'Any' ? '' : item)"
            >{{ item }}</AdvBtn
            >
        </div>

        <div class="adv-progress-wrap" v-if="!platform.isMobile">
            <AdvProgress :value="progress()"></AdvProgress>
        </div>
    </div>
</template>
<script>
import AdvBtn from './components/btn.vue';
import AdvProgress from './components/progress.vue';
import AdvTitle from './components/title.vue';
export default {
    inject: ['progress', 'next'],
    data: function() {
        return {
            list: ['1+', '2+', '3+', '4+', 'Any']
        };
    },
    methods: {
        handleNext(item) {
            this.next({ bathrooms: item }, 'questionAnswer');
        }
    },
    components: {
        AdvBtn,
        AdvProgress,
        AdvTitle
    }
};
</script>
<style lang="scss"></style>
